import React from "react";

interface MessageBubbleProps {
  isMine: boolean;
  isFile?: boolean;
  children: React.ReactNode;
}

const MessageBubble = ({ isMine, isFile = false, children }: MessageBubbleProps) => (
  <div className={`
    ${isMine ? 'rounded-l-lg rounded-tr-lg' : 'rounded-r-lg rounded-tl-lg'}    
    p-4 w-2/3 overflow-hidden whitespace-normal break-words
    ${isFile ? 'flex items-center' : ''}
    bg-content${isMine ? '1' : '2'}
  `}>
    {children}
  </div>
);

export default MessageBubble;